export enum FieldKey {
  Email = `email`,
  Name = `name`,
  Department = `department`,
  Password = `password`,
  AgreedToTermsOfUse = `agreedToTermsOfUse`,
  Company = `company`,
  NumberOfEmployees = `numberOfEmployees`,
  NumberOfMaus = `numberOfMaus`,
}

export enum ErrorKey {
  AlreadyInvitedError = `alreadyInvitedError`,
}

export enum ValidationState {
  Valid = `valid`,
  Invalid = `invalid`,
  NotValidated = ``,
}
